export default __webpack_public_path__ + "static/media/mary.5aeacefc.png";